export const SEARCH_RESULTS_PATH_REGEX = /\/providers\/specialty\/([^/]+)/i;

export const getSpecialtySlugFromPathname = (
  pathname: string,
): string | undefined => {
  const parts = pathname.split('/');
  const slug = parts[parts.length - 1];
  return slug === 'find' ? undefined : slug;
};
